// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3pr0Q","head":"ProcedureTableInfo_head__3g5tK"};